import { render, staticRenderFns } from "./GroupDetails.vue?vue&type=template&id=935d4cc2&scoped=true"
import script from "./GroupDetails.vue?vue&type=script&lang=ts"
export * from "./GroupDetails.vue?vue&type=script&lang=ts"
import style0 from "./GroupDetails.vue?vue&type=style&index=0&id=935d4cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935d4cc2",
  null
  
)

export default component.exports